module.exports = __webpack_public_path__ + "assets/img/submission-success.0a7e42e2.png";